import { get } from "lodash";
import { Store } from "redux";
import parseCAPIMessage from "@tvg/utils/capiUtils";
import { isMobile } from "@tvg/sh-utils/mobileUtils";
import {
  HomepageStoryblokConfig,
  HomepageStoryblokMobileConfig,
  HPTooltipMessage
} from "../types";
import { homeStoryblokConfigMock } from "../__mocks__/homeStoryblokConfigMock";
import { homeStoryblokConfigMobileMock } from "../__mocks__/homeStoryblokConfigMobileMock";
import { layoutSelectorIconTooltip } from "./defaultValues";

export const getHomepageTemplates = (
  store: Store
): HomepageStoryblokConfig | HomepageStoryblokMobileConfig =>
  get(
    store,
    "homepageTemplates",
    isMobile() ? homeStoryblokConfigMobileMock : homeStoryblokConfigMock
  );

export const getEnableHorseRacing101 = (store: Store): boolean =>
  get(store, "capi.featureToggles.horseRacing101", false);

export const getEnableHomepagePillsNav = (store: Store) =>
  get(store, "capi.featureToggles.enableHomepagePillsNav", false);

export const getHasCrossNavigation = (store: Store) =>
  get(store, "app.hasCrossNavigation", false);

export const getTemplateUserPreference = (store: Store): string =>
  get(store, "homepageTemplates.templateUserPreference", "default");

export const getQuickLinks = (store: Store) =>
  get(store, "quickLinks.content.links", []);

export const getLayoutSelectorIconTooltip = (store: Store) => {
  const hpCustomMessages = parseCAPIMessage(
    store,
    "capi.messages.HPCustomMessages"
  );
  return (
    hpCustomMessages.layoutSelectorIconTooltip ?? layoutSelectorIconTooltip
  );
};

export const getHPTooltipFeatureMessage = (store: Store): HPTooltipMessage => {
  const hpCustomMessages = parseCAPIMessage(
    store,
    "capi.messages.HPCustomMessages",
    {}
  );

  return get(hpCustomMessages, "HPWelcomeFeature", {});
};
